import {
  HeroRoot,
  HeroContainer,
  CopyColumn,
  ImageWrapper,
  Title,
  Description,
  CallToAction,
  Feature,
  FeaturesContainer,
  ImageColumn,
} from './RecipeDetailHero.styles'
import { useTranslation } from 'hooks/useTranslation'
import { Text } from 'components/Text'
import { Icon } from 'components/Icon'
import { Button } from 'components/Button'
import Image, { StaticImageData } from 'next/image'
import { InformationCollapse, InformationCollapseType } from 'features/components/ProductDetailHero/components/InformationCollapse'
import Link from 'next/link'
import { TranslationKeys } from 'locales/translationKeys'
import { Nutrition } from 'models/Nutrition'
import { nutritionFormatter } from 'features/Recipes/utils/nutritionFormatter'

export type RecipeDetailHeroProps = {
  imageSrc: StaticImageData
  imageAlt: TranslationKeys
  title: TranslationKeys
  features: TranslationKeys[]
  description: TranslationKeys
  infoList: InformationCollapseType[]
  nutrition: Nutrition
}

export const RecipeDetailHero = ({ imageSrc, imageAlt, title, features, description, infoList, nutrition }: RecipeDetailHeroProps) => {
  
  const { t } = useTranslation()

  const formattedNutrition = nutritionFormatter(nutrition)

  return (
    <HeroRoot>
      <HeroContainer>
        <CopyColumn>
          <Title>{t(title)}</Title>
          <FeaturesContainer>
            {features.map((feature, index) => (
              <Feature key={index}>
                <Icon size="4" color="primary-500" name="checkbox-circle-line" />
                <Text size="caption">{t(feature)}</Text>
              </Feature>
            ))}
          </FeaturesContainer>
          <Description>
            {t(description)}
          </Description>
          <CallToAction>
            {t('recipes:hero-v2.cta.text')}
          </CallToAction> 
          <Link passHref href="/meal-plan">
            <Button css={{ width: '330px', display: 'none', '@bp2': { display: 'block' } }}>
              {t('recipes:hero-v2.cta.button')}
            </Button>
          </Link>
          <InformationCollapse values={formattedNutrition} className="d-only" v2 infoList={infoList} />
        </CopyColumn>
        <ImageColumn>
          <ImageWrapper>
            <Image layout='fill' objectFit='cover' priority src={imageSrc} alt={t(imageAlt)} />
          </ImageWrapper> 
        </ImageColumn>
        <InformationCollapse values={formattedNutrition} className="m-only" v2 infoList={infoList} />  
      </HeroContainer>
    </HeroRoot>
  )
}

RecipeDetailHero.displayName = 'RecipeDetailHero'
